import React, { useEffect, useState, useRef  } from "react";
import { VStack, Badge, Box, Button, Heading, Text, Flex, useToast, Select, Input, Modal, ModalOverlay, ModalCloseButton, ModalContent, ModalHeader, ModalBody, ModalFooter, Switch, Popover, PopoverTrigger,PopoverContent,PopoverHeader,PopoverBody,PopoverArrow,PopoverCloseButton,  Slider,SliderTrack,SliderFilledTrack,SliderThumb,NumberInput,NumberInputField,NumberInputStepper,NumberIncrementStepper,NumberDecrementStepper,Tooltip,   Portal, Grid, ListItem, UnorderedList, useDisclosure, Spacer,
 } from "@chakra-ui/react";
import { MdArrowBack, MdInfo, MdDelete, MdOutlinePlayArrow, } from "react-icons/md";
import { react_api } from "../../config";
import { CASE_TYPE } from "../../CaseTypeCostant";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";
import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";

import { useTranslation } from "react-i18next";
import { useSession } from "../../SessionContext";
import { useNavigate } from "react-router-dom";
import SpinnerXL from "../SpinnerXL";
import { MultiSelect } from "react-multi-select-component";
import { useBreakpointValue } from "@chakra-ui/react";

const getBackgroundColorByVisibility = (visibility) => {
if (visibility === "private") {
    return "green.400";
} else if (visibility === "obtained") {
    return "orange.400";
} else if (visibility === "public") {
    return "yellow.400";
} else if (visibility === "general") {
    return "blue.400";
} else {
    return "blue.500";
}
};
const DatasetItem = ({ id, text, visibility, onSelect, isSelected }) => {
    let buttonColor = isSelected ? "gray.400" : getBackgroundColorByVisibility(visibility);
    return (
        <Button
        h="20px"
        bg={buttonColor}
        borderWidth={1}
        borderColor={"black"}
        onClick={()=> onSelect(text)}
        isDisabled={isSelected} 
        maxW="100%" 
        overflow="hidden" 
        textOverflow="ellipsis" 
        whiteSpace="nowrap"
        display="inline-block"
        >
        {text}
        </Button>
    );
};

const CategoryBox = ({ id, name, color, items, onSelect, selectedDataset, t, searchTerm, onSearchChange, }) => {
    const filteredItems = items.filter((item) =>
        item.table_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <Box key={id} mt={4} p={3} borderRadius="md" borderWidth={2} borderColor={`${color}.500`}>
            <Heading fontSize="md" color={`${color}.600`} mb={2}>
            {name}
            </Heading>
            <Input
            bg={"white"}
            placeholder={`${t("dataAnalysis.datasetBox.searchDataset")}${name}`}
            value={searchTerm}
            onChange={(e) => onSearchChange(id, e.target.value)}
            mb={2}
            />
            {filteredItems.length > 0 ? (
            filteredItems.map(({ table_id, table_name, visibility }) => (
                <DatasetItem
                key={table_id}
                id={{ id: table_name, type: "dataset" }}
                text={table_name}
                visibility={visibility}
                onSelect={onSelect}
                isSelected={selectedDataset === table_name}
                />
            ))
            ) : (
            <Text color="gray.500">{t("dataAnalysis.datasetBox.noDatasetsAvailable")}</Text>
            )}  
        </Box>
    );
};

function DataAnalysis() {
    const { t } = useTranslation();
    const [catalog, setCatalog] = useState([]);
    const [selectedDataset, setSelectedDataset] = useState(null);
    const [columns, setColumns] = useState([]);
    const toast = useToast();
    const navigate = useNavigate();
    const { updateSessionData, clearSessionData } = useSession();
    const axiosInstance = createAxiosInstance(async (axiosInstance) => {
        logout(t, clearSessionData, navigate, toast, axiosInstance);
    });
    const [selectAll, setSelectAll] = useState(false);
    const [operations, setOperations] = useState([]);
    const [subBasicOperations, setSubBasicOperations] = useState([]);
    const [subRegressionOperations, setSubRegressionOperations] = useState([]);
    const [onChiSquaredTest, setOnChiSquaredTest] = useState(false);
    const [firstValueCst, setFirstValueCst] = useState([]);
    const [secondValueCst, setSecondValueCst] = useState("");
    const [onLinearRegression, setOnLinearRegression] = useState(false);
    const [firstValueLr, setFirstValueLr] = useState([]);
    const [secondValueLr, setSecondValueLr] = useState("");
    const [onRegularizedLinearRegression, setOnRegularizedLinearRegression] = useState(false);
    const [firstValueRlr, setFirstValueRlr] = useState([]);
    const [secondValueRlr, setSecondValueRlr] = useState("");
    const sliderContainerRef = useRef(null);
    const [sliderValueRlr, setSliderValueRlr] = useState(0.00);
    const [numericValueRlr, setNumericValueRlr] = useState(0.00);
    const [resultApp, setResultApp] = useState(false);
    const [htmlResult, setHtmlResult] = useState("");
    const operationBasicStatistic = ["Descriptive stats", "Pearson correlation", "Spearman correlation", "Chi-squared test", "Pair plot", "Histogram plot"];
    const operationRegression = ["Linear regression", "Regularized linear regression"];
    const selectedColumns = Array.isArray(columns) ? columns.filter((col) => col.selected).map((col) => col.columnName) : [];
    const showOperations = selectedColumns.length >= 2;
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [pendingOperation, setPendingOperation] = useState(null);

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                const richiesta = {
                    BearerToken: sessionStorage.getItem("token"),
                    username: sessionStorage.getItem("username"),
                    caseType: CASE_TYPE.CATALOG_ALL,
                };
                const options = {
                    headers: {
                    "Content-Type": "application/json",
                    }
                };
                const urlFetch = `${react_api}/DragAndDrop/getDatasetsADP`;
                const response = await axiosInstance.post(urlFetch, richiesta, options);
                const result = response.data;
                const tablesInfo = result?.tables_info;

                if ( result == null || (Object.keys(result).length === 0)) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('messageBE.momentaryCommunicationError'), 
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;  
                }

                if (!Array.isArray(tablesInfo) || tablesInfo.length === 0) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('toastMsg.momentaryCommunicationError'),
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;
                }
                if (result.status !== HTTP_STATUS_CODES.OK) {
                    toast({
                    title: t('toastMsg.error'),
                    description: t(`messageBE.${result.message}`),
                    position: "top",
                    status: 'error',
                    duration: 4000,
                    isClosable: true
                    });
                }
                if (result.status === HTTP_STATUS_CODES.OK) {
                    setCatalog(result.tables_info);
                }
            } catch (error) {
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
            }
        };
        fetchCatalog();
    }, [toast]);

    const fetchColumns = async (tableId) => {
        try {
            const urlFetch = `${react_api}/DragAndDrop/getDatasetColADP/${tableId}`;
            const response = await axiosInstance.get(urlFetch);
            const result = response?.data;

            if ( result == null || (Object.keys(result).length === 0)) {
                toast({
                    title: t('toastMsg.error'),
                    description: t('messageBE.momentaryCommunicationError'), 
                    status: 'warning',
                    duration: 4000,
                    isClosable: true,
                    position: 'top'
                });
                return;  
            }

            return result;

        } catch (error) {
            toast({
            title: t('toastMsg.callError'),
            description: String(error),
            position: "top",
            status: "warning",
            duration: 4000,
            isClosable: true,
            });
        }
    };
    
    const sendDataToBackend = async () => {
        try {
        setSpinnerLoading(true);
        const selectedColumnsNames = columns.filter((col) => col.selected).map((col) => col.columnName);
        const payload = {
            BearerToken: sessionStorage.getItem("token"),
            username: sessionStorage.getItem("username"),
            service_name: "dataAnalysis",
            dataset: selectedDataset,
            columns: selectedColumnsNames,
            operation: operations,
            subBasicOperations: subBasicOperations,
            firstValueCst: firstValueCst, 
            secondValueCst: secondValueCst,
            subRegressionOperations: subRegressionOperations,
            firstValueLr: firstValueLr, 
            secondValueLr: secondValueLr,
            firstValueRlr: firstValueRlr, 
            secondValueRlr: secondValueRlr,
            sliderValueRlr: sliderValueRlr.toFixed(2),
            numericValueRlr: numericValueRlr.toFixed(2),
        };
        const urlFetch = `${react_api}/linkInternalServicesHTMLReceivedADP`;
        const response = await axiosInstance.post(urlFetch, payload);
        const result = response?.data;

        if ( result == null || (Object.keys(result).length === 0)) {
            toast({
                title: t('toastMsg.error'),
                description: t('messageBE.momentaryCommunicationError'), 
                status: 'warning',
                duration: 4000,
                isClosable: true,
                position: 'top'
            });
            return;  
        }
        if (result.status == undefined) {
            setSpinnerLoading(false);
            toast({
                title: t("toastMsg.error"),
                description: "Invalid token",
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
            return;
        }
        if (result.status !== HTTP_STATUS_CODES.OK) {
            setSpinnerLoading(false);
            toast({
            title: t("toastMsg.error"),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: "error",
            duration: 4000,
            isClosable: true,
            });
        }
        if (result.status === HTTP_STATUS_CODES.OK) {
            setSpinnerLoading(false);
            toast({
                title:  t(`toastMsg.dataAnalysis.dataAnalysisSuccessful`),
                // description: t(`messageBE.${result.message}`),
                position: "top",
                status: "success",
                duration: 4000,
                isClosable: true,
            });
            setHtmlResult(result.htmlPage);
            setResultApp(true);
        }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t("toastMsg.callError"),
                description: String(error.message),
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
        }
    };
    
    const [searchTerms, setSearchTerms] = useState({});
    
    const handleSearchChange = (categoryId, value) => {
        setSearchTerms((prev) => ({ ...prev, [categoryId]: value }));
    };

    const categories = [
        { id: 1, name: "Catalog General", type: "catalogo_generale", color: "blue" },
        { id: 2, name: "Catalog Results", type: "catalogo_risultati", color: "green" },
        { id: 3, name: "Catalog Processing", type: "catalogo_elaborazioni", color: "orange" },
        { id: 4, name: "Catalog Staging", type: "catalogo_staging", color: "purple" },
    ];

    const clearAllData = () => {
        clearBasicData();
        clearRegressionData();
        setOperations([]);
        setColumns([]);
        setSelectedDataset(null);
        setSelectAll(false);
        setSearchTerms({});
    };

    const clearBasicData = () => {
        setSubBasicOperations([]);
        setOnChiSquaredTest(false);
        setFirstValueCst([]);
        setSecondValueCst("");
    };

    const clearRegressionData = () => {
        setSubRegressionOperations([]);
        setOnLinearRegression(false);
        setFirstValueLr([]);
        setSecondValueLr("");
        setOnRegularizedLinearRegression(false);
        setFirstValueRlr([]);
        setSecondValueRlr("");
        setSliderValueRlr(0.0);
        setNumericValueRlr(0.0);
    };

    const handleDatasetSelect = (dataset) => {
        clearAllData();
        setSelectedDataset(dataset);
        const selectedTable = catalog.find((item) => item.table_name === dataset);
        if (selectedTable) {
            fetchColumns(selectedTable.table_id).then((columnRes) => {
                const sortedColumns = columnRes.tableInfo.sort((a, b) => a.index - b.index);
                const columnsRemoved = ['metadata_vd', 'metadata_vtd', 'metadata_ud'];
                const filteredColumns = sortedColumns.filter(
                    (col) => !columnsRemoved.includes(col.columnName)
                );
                setColumns(filteredColumns);
            });
        }
    };

    const toggleColumn = (index) => {
        const newColumns = columns.map((col, i) =>
            i === index ? { ...col, selected: !col.selected } : col
        );
        const newSelectedCount = newColumns.filter((col) => col.selected).length;
        if (newSelectedCount < 2) {
            clearBasicData();
            clearRegressionData();
            setOperations([]);
        }
        if (!newColumns.every((col) => col.selected)) {
            setSelectAll(false);
        } else {
            setSelectAll(true);
        }
        setColumns(newColumns);
    };

    const toggleAllColumns = () => {
        if (selectAll === true) {
            clearBasicData();
            clearRegressionData();
            setOperations([]);
        }
        setSelectAll(!selectAll);
        setColumns((prev) => prev.map((col) => ({ ...col, selected: !selectAll })));
    };

    const handleConfirm = () => {
        if (pendingOperation === "Basic Statistic") {
            clearBasicData();
        } else if (pendingOperation === "Regression") {
            clearRegressionData();
        }
        setOperations(prev => prev.filter(op => op !== pendingOperation));
        setPendingOperation(null);
        onClose();
    };

    const toggleOperation = (operation) => {
        if (operations.includes(operation)) {
            setPendingOperation(operation);
            onOpen();
        } else {
            setOperations(prev => [...prev, operation]);
        }
    };

    const toggleSubBasicOperation = (operation) => {
        if (operation === "Chi-squared test") {
            setOnChiSquaredTest(!onChiSquaredTest);
            if (onChiSquaredTest) {
                setFirstValueCst([]);
                setSecondValueCst("");
            }
        }
        setSubBasicOperations((prev) =>
            prev.includes(operation) ? prev.filter((op) => op !== operation) : [...prev, operation]
        );
    };
    const toggleSubRegressionOperation = (operation) => {
        if (operation === "Linear regression") {
            setOnLinearRegression(!onLinearRegression);
            if (onLinearRegression) {
                setFirstValueLr([]);
                setSecondValueLr("");
            }
        }
        if (operation === "Regularized linear regression") {
            setOnRegularizedLinearRegression(!onRegularizedLinearRegression);
            if (onRegularizedLinearRegression) {
                setFirstValueRlr([]);
                setSecondValueRlr("");
                setSliderValueRlr(0.00);
                setNumericValueRlr(0.00);
            }
        }
        setSubRegressionOperations((prev) =>
            prev.includes(operation) ? prev.filter((op) => op !== operation) : [...prev, operation]
        );
    };

    const getOperationColor = (operation) => {
        return operations.includes(operation) ? "rgba(11,78,90,255)" : "gray.300";
    };

    // Funzione per gestire il MultiSelect: converte l'array di oggetti in array di stringhe
    const handleMultiSelectChange = (select, selected) => {
        const values = selected.map((item) => item.value);
        handleSelectOptions(values, select);
    };

    const handleSelectOptions = (value, select) => {
        switch (select) {
        case "firstCst":
            setFirstValueCst(Array.isArray(value) ? value : [value]);
            if (value.includes(secondValueCst)) {
            setSecondValueCst("");
            }
            break;
        case "secondCst":
            setSecondValueCst(value);
            setFirstValueCst((prev) =>
            Array.isArray(prev) ? prev.filter((col) => col !== value) : []
            );
            break;
        case "firstLr":
            setFirstValueLr(Array.isArray(value) ? value : [value]);
            if (value.includes(secondValueLr)) {
            setSecondValueLr("");
            }
            break;
        case "secondLr":
            setSecondValueLr(value);
            setFirstValueLr((prev) =>
            Array.isArray(prev) ? prev.filter((col) => col !== value) : []
            );
            break;
        case "firstRlr":
            setFirstValueRlr(Array.isArray(value) ? value : [value]);
            if (value.includes(secondValueRlr)) {
            setSecondValueRlr("");
            }
            break;
        case "secondRlr":
            setSecondValueRlr(value);
            setFirstValueRlr((prev) =>
            Array.isArray(prev) ? prev.filter((col) => col !== value) : []
            );
            break;
        case "sliderValueRlr":
            setSliderValueRlr(value);
            break;
        case "numericValueRlr":
            setNumericValueRlr(value);
            break;
        default:
            break;
        }
    };

    const isStartDisabled = () => {
        if (!selectedDataset) return true;
        if (columns.filter((c) => c.selected).length < 2) return true;
        if (operations.length === 0) return true;
        if (operations.includes("Basic Statistic")) {
        if (subBasicOperations.length === 0) return true;
        if (subBasicOperations.includes("Chi-squared test")) {
            if (firstValueCst.length === 0 || !secondValueCst) return true;
        }
        }
        if (operations.includes("Regression")) {
        if (subRegressionOperations.length === 0) return true;
        if (subRegressionOperations.includes("Linear regression")) {
            if (firstValueLr.length === 0 || !secondValueLr) return true;
        }
        if (subRegressionOperations.includes("Regularized linear regression")) {
            if (firstValueRlr.length === 0 || !secondValueRlr) return true;
        }
        }
        return false;
    };   
    
    const clearResult = () =>{
        setResultApp(false);
        setHtmlResult("");
    };

    useEffect(() => {
        if (isStartDisabled()) {
            clearResult();
        }
    }, [
        selectedDataset, 
        columns, 
        operations, 
        subBasicOperations, 
        subRegressionOperations, 
        firstValueCst, 
        secondValueCst, 
        firstValueLr, 
        secondValueLr, 
        firstValueRlr, 
        secondValueRlr
    ]);

    const responsiveHeight = useBreakpointValue({
        base: "auto",
        md: "80vh",
        lg: "calc(100vh - 70px)" 
    });

    return (
        <Box position="relative" height="100%" width="100%" p={2} bg="#f6f3ec">
            {spinnerLoading && (
                <SpinnerXL />
            )}
            <Flex mb={2} align="center" gap={2} pr={3}>
                <Heading color={"rgba(11,78,90,255)"}>Data Analysis</Heading>
                <Spacer />
                {!resultApp && (
                    <>
                        <Button size="sm" variant="outline" colorScheme="red" _hover={{bg: "red.500", color: "white",}} onClick={() => clearAllData()}>{t('dataAnalysis.btnClearData')} <MdDelete size={18} /></Button>
                        <Button size="sm" variant="outline" _hover={{bg: "green.500", color: "white",}} colorScheme="green" onClick={sendDataToBackend} isDisabled={isStartDisabled()}>{t('dataAnalysis.btnStart')} <MdOutlinePlayArrow size={18} /></Button>
                    </>
                )}
                {resultApp && (
                    <Button p={3} gap={2} size="sm" variant="outline" _hover={{bg: "teal.500", color: "white",}} colorScheme="teal" onClick={()=>setResultApp(false)}><MdArrowBack size={18} />{t('dataAnalysis.btnBack')}</Button>
                )}
            </Flex>
            <Flex height={responsiveHeight} gap={2} align="flex-start" overflowX="auto">
                    <Box borderColor="rgba(23, 141, 161, 1)" backgroundColor="rgba(230, 232, 232, 1)" borderRadius={5} borderWidth={2} overflowY="auto" height="100%" width="15%" p={4} >
                        <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.summaryBox.summary')}:</Text>
                        {selectedDataset && (
                            <>
                                <Text fontWeight="semibold">Dataset :</Text>
                                <Tooltip label={selectedDataset} hasArrow>
                                    <Badge colorScheme="teal" fontWeight="normal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                        {selectedDataset}
                                    </Badge>
                                </Tooltip>
                            </>
                        )}
                        {selectedColumns.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumColumns')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {selectedColumns.map((col, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={col} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {col}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {operations.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumOperations')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {operations.map((operation, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={operation} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" display="inline-block">
                                                {operation}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {subBasicOperations.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumOperationsBasicStatistics')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {subBasicOperations.map((suOperation, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={suOperation} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {suOperation}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {firstValueCst.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumChiSquaredTestFeatures')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {firstValueCst.map((firstValues, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={firstValues} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {firstValues}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {secondValueCst.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumChiSquaredTestTarget')}:</Text>
                                <Tooltip label={secondValueCst} hasArrow>
                                    <Badge fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                    {secondValueCst}
                                    </Badge>
                                </Tooltip>
                            </>
                        )}
                        {subRegressionOperations.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumOperationsRegression')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {subRegressionOperations.map((subRegresOperation, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={subRegresOperation} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {subRegresOperation}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {firstValueLr.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumLinearRegressionFeatures')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {firstValueLr.map((firstValueLr, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={firstValueLr} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {firstValueLr}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {secondValueLr.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumLinearRegressionTarget')} :</Text>
                                <Tooltip label={secondValueLr} hasArrow>
                                    <Badge fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                    {secondValueLr}
                                    </Badge>
                                </Tooltip>
                            </>
                        )}
                        {firstValueRlr.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumRegularizedLinearRegressionFeatures')} :</Text>
                                <VStack spacing={1} wrap="wrap" align="start">
                                    {firstValueRlr.map((firstValueRlr, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={firstValueRlr} hasArrow>
                                                <Badge key={index} fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {firstValueRlr}
                                                </Badge>
                                            </Tooltip>
                                        </Flex>
                                    ))}
                                </VStack>
                            </>
                        )}
                        {secondValueRlr.length > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumRegularizedLinearRegressionTarget')} :</Text>
                                <Tooltip label={secondValueRlr} hasArrow>
                                    <Badge fontWeight="normal" colorScheme="teal" variant="solid" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                    {secondValueRlr}
                                    </Badge>
                                </Tooltip>
                            </>
                        )}
                        {onRegularizedLinearRegression && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumElasticNet')} :</Text>
                                <Badge fontWeight="normal" colorScheme="teal" variant="solid">
                                    {sliderValueRlr.toFixed(2)}
                                </Badge>
                            </>
                        )}
                        {onRegularizedLinearRegression > 0 && (
                            <>
                                <Text fontWeight="semibold">{t('dataAnalysis.summaryBox.sumRegularisationParameter')} :</Text>
                                <Badge fontWeight="normal" colorScheme="teal" variant="solid">
                                    {numericValueRlr.toFixed(2)}
                                </Badge>
                            </>
                        )}
                    </Box>
                
                {!resultApp && (
                    <>
                        <Box borderWidth={2} overflowY="scroll" borderColor="rgba(23, 141, 161, 1)" borderRadius={5} height="100%" width="30%" p={3}>
                            <Box justifyContent="space-between">
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Dataset</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('dataAnalysis.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="green" variant="solid">Private</Badge>
                                    <Badge ml={2} colorScheme="yellow" variant="solid">Public</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Obtained</Badge>
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                </Box>
                            </Box>
    
                            <Box justifyContent="space-between" mt={"1%"}>
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Catalog</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('dataAnalysis.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                    <Badge ml={2} colorScheme="green" variant="solid">Results</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Processing</Badge>
                                    <Badge ml={2} colorScheme="purple" variant="solid">Staging</Badge>
                                </Box>
                            </Box>
                            {categories.map(({ id, name, color }) => {
                                const filteredCatalog = catalog.filter(item => Number(item.cataloguetype_id) === id);

                                return (
                                    <CategoryBox
                                        key={id}
                                        id={id}
                                        name={name}
                                        color={color}
                                        items={filteredCatalog}
                                        onSelect={handleDatasetSelect}
                                        selectedDataset={selectedDataset}
                                        searchTerm={searchTerms[id] || ""}
                                        onSearchChange={handleSearchChange}
                                        t={t}
                                    />
                                );
                            })}
                        </Box>
                        {selectedDataset && (
                            <Box borderColor="rgba(23, 141, 161, 1)" borderRadius={5} borderWidth={2} overflowY="auto" height="100%" width="15%" p={4}>
                                <Flex align="center" mb={2}>
                                    <Text mr={2}>{t('dataAnalysis.columnsBox.selectAll')} :</Text>
                                    <Switch colorScheme="teal" isChecked={selectAll} onChange={toggleAllColumns} />
                                </Flex>
                                <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.columnsBox.columns')} :</Text>
                                <VStack spacing={2} wrap="wrap" align="start">
                                    {columns.map((col, index) => (
                                        <Flex key={index} align="center" textOverflow="ellipsis" maxW="100%">
                                            <Tooltip key={index} label={col.columnName} hasArrow>
                                                <Badge key={index} color="black" border="1px solid #0888BE" bg="transparent" borderRadius="md" px={1} py={0} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"display="inline-block">
                                                {col.columnName}
                                                </Badge>
                                            </Tooltip>
                                            <Switch colorScheme="teal" ml={2} isChecked={col.selected} onChange={() => toggleColumn(index)} />
                                        </Flex>
                                    ))}
                                </VStack>
                            </Box>
                        )}
                        {showOperations && (
                            <Box borderColor="rgba(23, 141, 161, 1)" borderRadius={5} borderWidth={2} height="100%" width="40%" overflowY="auto" p={4} >
                                <Flex align="center">
                                    <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.operationsBox.operations')}:</Text>
                                    <Popover>
                                        <PopoverTrigger>
                                            <Button flexShrink="0" borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} >
                                                <MdInfo size={25} />
                                            </Button>
                                        </PopoverTrigger>
                                        <PopoverContent width="500px" maxHeight="350px" overflowY="auto">
                                            <PopoverArrow />
                                            <PopoverCloseButton />
                                            <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Operazioni:</Text></PopoverHeader>
                                            <PopoverBody>
                                                <UnorderedList spacing={1}>
                                                    <Text fontWeight="bold" color="rgb(0,128,128)">Basical statistical </Text>
                                                    <ListItem>Descriptive stats: {t('dataAnalysis.popover.infoDescriptiveStats')}</ListItem>
                                                    <ListItem>Pearson/Spearman corr: {t('dataAnalysis.popover.infoPearsonSpearman')}</ListItem>
                                                    <ListItem>Chi-squared test: {t('dataAnalysis.popover.infoChiSquaredTest')}</ListItem>
                                                    <ListItem>Pair plot: {t('dataAnalysis.popover.infoPairPlot')}</ListItem>
                                                    <ListItem>Histogram plot: {t('dataAnalysis.popover.infoHistogramPlot')}</ListItem>

                                                    <Text fontWeight="bold" color="rgb(0,128,128)">Regression</Text>
                                                    <ListItem>Linear regression: {t('dataAnalysis.popover.infoLinearRegression')}</ListItem>
                                                    <ListItem>Regularized linear regression: {t('dataAnalysis.popover.infoRegularizedLinearRegression')}</ListItem>
                                                </UnorderedList>
                                            </PopoverBody>
                                        </PopoverContent>
                                    </Popover>
                                    <Button mx={2} whiteSpace="nowrap" minWidth="10%" overflow="hidden" textOverflow="ellipsis"   
                                        onClick={() => toggleOperation("Basic Statistic")} bg={getOperationColor("Basic Statistic")} 
                                        color={operations.includes("Basic Statistic") ? "white" : "black"}
                                        _hover={{
                                            bg: operations.includes("Basic Statistic") ? "rgba(8, 60, 70, 255)" : "gray.400", 
                                            color: operations.includes("Basic Statistic") ? "white" : "black"
                                        }}
                                    > Basic Statistics </Button>
                                    <Button whiteSpace="nowrap" minWidth="10%" overflow="hidden" textOverflow="ellipsis"   
                                        onClick={() => toggleOperation("Regression")} bg={getOperationColor("Regression")} 
                                        color={operations.includes("Regression") ? "white" : "black"}
                                        _hover={{
                                            bg: operations.includes("Regression") ? "rgba(8, 60, 70, 255)" : "gray.400",
                                            color: operations.includes("Regression") ? "white" : "black"
                                        }}
                                    > Regression </Button>
                                </Flex>                             
                                {operations.includes("Basic Statistic") && (
                                    <Box borderRadius={10} borderWidth={2} p={4} mt={4} width="100%">
                                        <Text mb={1} fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Basic Statistics:</Text>
                                        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={1}>
                                            {operationBasicStatistic.map((subOp) => (
                                                <Flex key={subOp} align="center" textOverflow="ellipsis" maxW="100%">
                                                    <Text mr={2} maxW="100%" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal" display="inline-block">{subOp}</Text>
                                                    <Switch colorScheme="teal" onChange={() => toggleSubBasicOperation(subOp)} isChecked={subBasicOperations.includes(subOp)} />
                                                </Flex>
                                            ))}
                                        </Grid>
                                    </Box>
                                )}
                                {onChiSquaredTest && (
                                    <Box borderRadius={10} borderWidth={2} p={2} mt={4} width="100%"  overflow="visible">
                                        <Flex align="center">
                                            <Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Chi-squared Test:</Text>
                                            <Popover>
                                                <PopoverTrigger>
                                                    <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                                        <MdInfo size={20} />
                                                    </Button>
                                                </PopoverTrigger>
                                                <PopoverContent>
                                                    <PopoverArrow />
                                                    <PopoverCloseButton />
                                                    <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.popover.operation')} Chi-squared Test:</Text></PopoverHeader>
                                                    <PopoverBody>{t('dataAnalysis.popover.infoChiSquaredTest&LinearRegressionOperations')}</PopoverBody>
                                                </PopoverContent>
                                            </Popover>
                                        </Flex>
                                        <Flex gap={4}>
                                            <Box flex={1} maxW="50%">
                                                <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.selectFeatures')} :</Text>
                                                <MultiSelect
                                                    options={selectedColumns
                                                        .filter((col) => col !== secondValueCst)
                                                        .map((col) => ({ value: col, label: col }))}
                                                    value={firstValueCst.map((val) => ({ value: val, label: val }))}
                                                    onChange={(selected) => handleMultiSelectChange("firstCst", selected)}
                                                    labelledBy={t('dataAnalysis.operationsBox.selectFeatures')} 
                                                />
                                            </Box>
                                            <Box flex={1}>
                                                <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.targetColumnSelection')}</Text>
                                                <Select
                                                    bg={"white"}
                                                    placeholder={t('dataAnalysis.operationsBox.selectTarget')}
                                                    value={secondValueCst}
                                                    onChange={(e) => handleSelectOptions(e.target.value, "secondCst")}
                                                >
                                                {selectedColumns
                                                    .filter((col) => !firstValueCst.includes(col))
                                                    .map((col, index) => (
                                                    <option key={index} value={col}>
                                                        {col}
                                                    </option>
                                                    ))}
                                                </Select>
                                            </Box>
                                        </Flex>
                                    </Box>
                                )}
                                {operations.includes("Regression") && (
                                    <Box borderRadius={10} borderWidth={2} p={4} mt={4} width="100%">
                                        <Text mb={1} fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Regression:</Text>
                                        <Grid templateColumns="1fr 1fr" gap={1}>
                                            {operationRegression.map((subOp) => (
                                                <Flex key={subOp} align="center" textOverflow="ellipsis" maxW="100%">
                                                    <Text overflow="hidden" textOverflow="ellipsis" whiteSpace="normal" display="inline-block" mr={1}>{subOp}</Text>
                                                    <Switch colorScheme="teal" onChange={() => toggleSubRegressionOperation(subOp)} isChecked={subRegressionOperations.includes(subOp)} />
                                                </Flex>
                                            ))}
                                        </Grid>
                                    </Box>
                                )}
                                {onLinearRegression && (
                                    <Box borderRadius={10} borderWidth={2} p={4} mt={4} width="100%" overflow="visible">
                                        <Flex align="center">
                                            <Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Linear regression :</Text>
                                            <Popover>
                                                <PopoverTrigger>
                                                    <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                                        <MdInfo size={20} />
                                                    </Button>
                                                </PopoverTrigger>
                                                <PopoverContent>
                                                    <PopoverArrow />
                                                    <PopoverCloseButton />
                                                    <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.popover.operation')} Linear regression:</Text></PopoverHeader>
                                                    <PopoverBody>{t('dataAnalysis.popover.infoChiSquaredTest&LinearRegressionOperations')}</PopoverBody>
                                                </PopoverContent>
                                            </Popover>
                                        </Flex>
                                        <Flex gap={4}>
                                            <Box flex={1} maxW="50%">
                                                <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.selectFeatures')} :</Text>
                                                <MultiSelect
                                                    options={selectedColumns
                                                        .filter((col) => col !== secondValueLr)
                                                        .map((col) => ({ value: col, label: col }))}
                                                    value={firstValueLr.map((val) => ({ value: val, label: val }))}
                                                    onChange={(selected) => handleMultiSelectChange("firstLr", selected)}
                                                    labelledBy={t('dataAnalysis.operationsBox.selectFeatures')}
                                                />
                                            </Box>
                                            <Box flex={1}>
                                                <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.targetColumnSelection')} :</Text>
                                                <Select
                                                    bg={"white"}
                                                    placeholder={t('dataAnalysis.operationsBox.selectTarget')}
                                                    value={secondValueLr}
                                                    onChange={(e) => handleSelectOptions(e.target.value, "secondLr")}
                                                >
                                                {selectedColumns
                                                    .filter((col) => !firstValueLr.includes(col))
                                                    .map((col, index) => (
                                                    <option key={index} value={col}>
                                                        {col}
                                                    </option>
                                                    ))}
                                                </Select>
                                            </Box>
                                        </Flex>    
                                    </Box>
                                )}
                                <Flex align="flex-start" overflow="visible">
                                    {onRegularizedLinearRegression && (
                                        <Box ref={sliderContainerRef} position="relative"  borderRadius={10} borderWidth={2} p={4} mt={4} width="100%">
                                            <Flex align="center">
                                                <Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">Regularized Linear Regression :</Text>
                                                <Popover placement="top">
                                                    <PopoverTrigger>
                                                        <Button borderRadius="50" bg="transparent" color="teal.600" _hover={{ color: "teal.400", bg: "transparent" }} p={0}>
                                                            <MdInfo size={20} />
                                                        </Button>
                                                    </PopoverTrigger>
                                                    <Portal>
                                                        <PopoverContent>
                                                            <PopoverArrow />
                                                            <PopoverCloseButton />
                                                            <PopoverHeader><Text fontSize="md" color="rgba(11,78,90,255)" fontWeight="bold">{t('dataAnalysis.popover.operation')} Regularized Linear Regression:</Text></PopoverHeader>
                                                            <PopoverBody>{t('dataAnalysis.popover.infoRegularizedLinearRegressionOperation')}</PopoverBody>
                                                        </PopoverContent>
                                                    </Portal>
                                                </Popover>
                                            </Flex>
                                            <Flex gap={4}>
                                                <Box flex={1} maxW="50%">
                                                    <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.selectFeatures')} :</Text>
                                                    <MultiSelect
                                                        options={selectedColumns
                                                            .filter((col) => col !== secondValueRlr)
                                                            .map((col) => ({ value: col, label: col }))}
                                                        value={firstValueRlr.map((val) => ({ value: val, label: val }))}
                                                        onChange={(selected) => handleMultiSelectChange("firstRlr", selected)}
                                                        labelledBy={t('dataAnalysis.operationsBox.selectFeatures')}
                                                    />
                                                </Box>
                                                <Box flex={1} ml={4}>
                                                    <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.elasticNet')} (0.00 - 1.00):</Text>
                                                    <Slider mt={8} aria-label="slider" value={sliderValueRlr} onChange={(val) => {setSliderValueRlr(val); handleSelectOptions(val, "sliderValueRlr");}} min={0.00} max={1.00} step={0.01}>
                                                        <SliderTrack>
                                                            <SliderFilledTrack bg="rgba(0,128,128)" />
                                                        </SliderTrack>
                                                        <Tooltip hasArrow bg="rgba(0,128,128)" fontSize="xs" placement="top" isOpen={true} label={sliderValueRlr.toFixed(2)} portalProps={{ containerRef: sliderContainerRef }} >
                                                            <SliderThumb bg="rgba(0,128,128)" boxSize={4} />
                                                        </Tooltip>
                                                    </Slider>
                                                </Box>
                                            </Flex>
                                            <Flex gap={4}>
                                                <Box flex={1} maxW="50%">
                                                    <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.targetColumnSelection')} :</Text>
                                                        <Select
                                                            bg={"white"}
                                                            placeholder={t('dataAnalysis.operationsBox.selectTarget')}
                                                            value={secondValueRlr}
                                                            onChange={(e) => handleSelectOptions(e.target.value, "secondRlr")}
                                                        >
                                                        {selectedColumns
                                                            .filter((col) => !firstValueRlr.includes(col))
                                                            .map((col, index) => (
                                                            <option key={index} value={col}>
                                                                {col}
                                                            </option>
                                                            ))}
                                                        </Select>
                                                </Box>
                                                <Box flex={1}>
                                                    <Text fontWeight="semibold" my={2}>{t('dataAnalysis.operationsBox.regularisationParameter')} :</Text>
                                                    <NumberInput
                                                        value={numericValueRlr.toFixed(2)}
                                                        onChange={(valueString, valueNumber) => {setNumericValueRlr(valueNumber); handleSelectOptions(valueNumber, "numericValueRlr");}}
                                                        step={0.01}
                                                        precision={2}
                                                    >
                                                        <NumberInputField />
                                                        <NumberInputStepper>
                                                        <NumberIncrementStepper />
                                                        <NumberDecrementStepper />
                                                        </NumberInputStepper>
                                                    </NumberInput>
                                                </Box>
                                            </Flex>
                                        </Box>
                                    )}
                                </Flex>
                            </Box>
                        )}
                    </>
                )}
                {resultApp && (
                    <Box borderColor="rgba(23, 141, 161, 1)" borderRadius={5} borderWidth={2} height="100%" width="85%">
                        <iframe
                            srcDoc={htmlResult}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            title="Data Analytics Results"
                            />
                    </Box>
                )}
            </Flex>
            
            <Modal isOpen={isOpen} onClose={() => { setPendingOperation(null); onClose(); }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('dataAnalysis.modal.confirmationCancellation')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {t('dataAnalysis.modal.infoConfirmationCancellation1')} <strong>{pendingOperation}</strong>?<br />
                        {t('dataAnalysis.modal.infoConfirmationCancellation2')}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleConfirm}>
                        {t('dataAnalysis.modal.yes')}
                        </Button>
                        <Button colorScheme="red" onClick={() => { setPendingOperation(null); onClose(); }}>
                        No
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            </Box>
        );
}

export default DataAnalysis;
